<!-- eslint-disable vue/no-mutating-props -->

<!-- eslint-disable vue/valid-v-for -->
<!-- eslint-disable vue/no-unused-vars -->
<template>
  <component
    :class="[$style['mds-card'], $style['cf-card-cardWrap-engagement']]"
    :is="componentType"
    :href="href"
  >
    <div v-if="label" :class="$style['mds-card__label']">
      <div :class="$style['mds-card__label-title']">{{ label }}</div>
    </div>

    <div
      :class="[$style['mds-card-image'], $style['cf-card-image-engagement']]"
    >
      <div :class="[$style['cf-card-profileWraper']]">
        <mds-profile-image
          :src="imagepath"
          :height="imageheight"
          :width="imagewidth"
          alt="Author Photo"
        ></mds-profile-image>
      </div>
      <div :class="$style['mds-card-caption']">
        <div>
          <div
            :class="[
              $style['mds-card__title'],
              $style['cf-card-title-engagement'],
            ]"
          >
            <slot>{{ title }}</slot>
          </div>

          <div
            v-if="caption"
            :class="[$style['mds-card__caption']]"
            v-html="caption"
          ></div>

          <div :class="[$style['cf-card-ButonsWrap']]">
            <div
              :class="[$style['cf-card-ButonsSingle']]"
              @click="toggle = !toggle"
              id="with-multi-sections-trigger"
            >
              <span>
                {{ firstlabel.text }}
              </span>
              <mds-icon
                v-if="firstSelectData.length > 1"
                name="caret-down"
                size="small"
                :class="[$style['caretICon']]"
              ></mds-icon>
            </div>

            <mds-popover
              v-if="firstSelectData.length > 1"
              triggered-by="with-multi-sections-trigger"
              v-model="toggle"
              width="200px"
            >
              <mds-list-group>
                <mds-list-group-item
                  @click.native="ListItem1Change(value)"
                  :isRoutable="true"
                  :collapsible="false"
                  v-for="(value, index) of firstSelectData"
                >
                  <span
                    :class="
                      firstOptionLabel.value == value.value
                        ? [$style['activelistcard']]
                        : []
                    "
                  >
                    <span>{{ value.text }}</span>

                    <span
                      v-if="firstOptionLabel.value == value.value"
                      style="position: absolute; right: 4px; top: 6px"
                    >
                      <mds-icon
                        :class="[$style['activelistsvgcard']]"
                        name="check"
                        size="small"
                      ></mds-icon>
                    </span>
                  </span>
                </mds-list-group-item>
              </mds-list-group>
            </mds-popover>

            <div
              :class="[$style['cf-card-ButonsSingle']]"
              @click="toggle1 = !toggle1"
              id="with-multi-sections-trigger2"
            >
              <span>
                {{ secondlabel.text }}
              </span>
              <mds-icon
                name="caret-down"
                size="small"
                :class="[$style['caretICon']]"
              ></mds-icon>
            </div>

            <mds-popover
              triggered-by="with-multi-sections-trigger2"
              v-model="toggle1"
              width="200px"
            >
              <mds-list-group>
                <mds-list-group>
                  <mds-list-group-item
                    @click.native="ListItem2Change(value)"
                    :isRoutable="true"
                    :collapsible="false"
                    v-for="(value, index) in secondSelectData"
                  >
                    <span
                      :class="
                        secondOptionLabel.value == value.value
                          ? [$style['activelistcard']]
                          : []
                      "
                    >
                      <span> {{ value.text }}</span>
                      <div
                        v-if="secondOptionLabel.value == value.value"
                        style="position: absolute; right: 4px; top: 6px"
                      >
                        <mds-icon
                          :class="[$style['activelistsvgcard']]"
                          name="check"
                          size="small"
                        ></mds-icon>
                      </div>
                    </span>
                  </mds-list-group-item>
                </mds-list-group>
              </mds-list-group>
            </mds-popover>
          </div>
        </div>
      </div>
    </div>
  </component>
</template>

<script>
import MdsProfileImage from "@mds/profile-image";
import MdsCard from "@mds/card";
import MdsSelect from "@mds/select";
import MdsPopover from "@mds/popover";
import { MdsListGroup, MdsListGroupItem } from "@mds/list-group";
import MdsIcon from "@mds/icon";

export default {
  name: "AdlCardDropdown",
  components: {
    MdsCard,
    MdsProfileImage,
    MdsSelect,
    MdsPopover,
    MdsListGroup,
    MdsListGroupItem,
    MdsIcon,
  },
  props: {
    firstOptionLabel: { type: Object },
    secondOptionLabel: { type: Object },
    firstSelectData: { type: Array },
    secondSelectData: { type: Array },
    imagepath: { type: String },
    caption: {
      type: String,
      docs: {
        validation: "—",
        description: "Sets the card caption.",
        support: ["v-html"],
      },
    },

    href: {
      type: String,
      docs: {
        validation: "—",
        description:
          "When provided, makes the entire card a link and sets the `href` path.",
      },
    },
    label: {
      type: String,
      docs: {
        validation: "—",
        description: "Sets the card label.",
      },
    },
    metadata: {
      type: String,
      docs: {
        validation: "—",
        description: "Sets the card metadata.",
        support: ["v-html"],
      },
    },
    size: {
      type: String,
      default: "medium",
      validator(value) {
        return ["small", "medium", "large"].indexOf(value) !== -1;
      },
      docs: {
        validation: "One of: `small`, `medium`, `large`.",
        description: "Sets the size of the card.",
      },
    },
    title: {
      type: String,
      required: true,
      docs: {
        validation: "**Required**",
        description: "Sets the card title.",
      },
    },
    imageheight: {
      type: String,
    },
    imagewidth: {
      type: String,
    },
  },
  computed: {
    componentType() {
      return this.isRoutable ? this.linkTag : this.href ? "a" : "div";
    },
    sizeClass() {
      return this.$style[`mds-card--${this.size}`];
    },

    classObject() {
      const obj = {};
      obj[this.$style["mds-card--full-bleed"]] = this.fullBleed;
      obj[this.$style["mds-card--full-bleed-top-label-overlap"]] =
        this.supplementalContentFirst && this.fullBleed;

      return obj;
    },
    combineddata() {
      let data = {
        option1: this.firstoptionselect,
        option2: this.secondoptionselect,
      };
      return data;
    },
  },
  methods: {
    ListItem1Change(value) {
      this.firstoptionselect = value;
      if (this.secondoptionselect.value == undefined) {
        this.secondoptionselect = this.secondOptionLabel;
      }
      this.firstlabel = value;
      this.toggle = !this.toggle;

      this.$emit("ListItemChange", this.combineddata);
    },
    ListItem2Change(value) {
      this.secondoptionselect = value;
      if (this.firstoptionselect.value == undefined) {
        this.firstoptionselect = this.firstOptionLabel;
      }
      this.secondlabel = value;
      this.toggle1 = !this.toggle1;

      this.$emit("ListItemChange", this.combineddata);
    },
  },

  data() {
    return {
      toggle: false,
      toggle1: false,
      firstoptionselect: {
        type: Object,
      },
      secondoptionselect: {
        type: Object,
      },
      firstlabel: this.firstOptionLabel,
      secondlabel: this.secondOptionLabel,
    };
  },
  watch: {
    firstOptionLabel(val) {
      this.firstlabel = val;
    },
    secondOptionLabel(val) {
      this.secondlabel = val;
    },
  },
};
</script>
<style scoped lang="scss" module>
@import "./card.scss";

.cf-card-cardWrap-engagement {
  padding: $mds-space-2-x $mds-space-2-x !important;
  width: 100%;
}

.cf-card-cardWrap-basic {
  padding: $mds-space-3-x $mds-space-2-x !important;
}

.mds-card {
  .cf-card-image-engagement {
    position: relative;
    padding-left: 56px;

    .mds-card-caption {
      min-width: 100% !important;
      margin-left: 0px !important;
    }
  }

  .cf-card-image-basic {
    position: relative;
    padding-left: 56px;

    .mds-card-caption {
      min-width: 270px !important;
      margin-left: 0px !important;
      min-height: 74px;
    }
  }

  .cf-card-title-engagement {
    @include mds-level-6-heading($bold: true);
    margin-bottom: 0;
    margin-top: 0px;
    font-size: 14px !important;
  }

  .cf-card-profileWraper {
    position: absolute;
    left: 0;
  }

  .cf-card-ButonsWrap > .cf-card-ButonsSingle {
    width: 50%;
    text-align: left;
    cursor: pointer;
    display: inline-flex;
    font-size: 14px;
  }

  .cf-card-ButonsWrap > .cf-card-ButonsSingle + .cf-card-ButonsSingle {
    padding-left: 8px;
  }

  .cf-card-ButonsWrap > .cf-card-ButonsSingle > span {
    text-overflow: ellipsis;
    white-space: nowrap !important;
    overflow: hidden;
  }

  .cf-card-ButonsWrap > .cf-card-ButonsSingle .caretICon {
    position: relative;
    top: 5px;
    flex-shrink: 0;
  }
}

.activelistcard {
  color: #0077cf !important;
}

.activelistsvgcard {
  stroke: #0077cf !important;
  fill: #0077cf !important;
}
</style>
